<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 12 }"
        :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="类型编号">
            <a-input :disabled="editStatus" v-decorator="['typeNo', rules.typeNo]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="类型名称">
            <a-input v-decorator="['typeName', rules.typeName]"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="显示顺序">
            <a-input v-decorator="['orderNum']"/>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-form-item label="备注" :label-col="{ span: 4 }"
                     :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['remark']"></a-textarea>
        </a-form-item>
      </a-row>

    </a-form>

    <a-tabs>
      <a-tab-pane key="1" tab="明细" :forceRender="true">
        <baseCodeTable ref="baseCodeTable" :rowId="rowId"></baseCodeTable>
      </a-tab-pane>
    </a-tabs>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save()">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/comm/commBaseCodeManage';

import baseCodeTable from "@/pages/web/comm/commBaseCodeManage/detail/baseCodeTable";

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    typeNo: {
      rules: [{required: true, message: "请输入类型编号"}]
    },
    typeName: {
      rules: [{required: true, message: "请输入类型名称"}]
    },
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  //给子表赋值
  this.$refs['baseCodeTable'].loadData(entity.codeList);
  this.editStatus = !!entity.typeNo;//是否可编辑用户账号
  this.createUserId = entity.createUserId;
  this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  /* let arr = await dataApi.getDealerList();
   console.log(arr)
   this.dealer = arr.data.map(val => {
       return {
           label: val.dealerName,
           value: val.dealerId
       }
   })*/
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //其他数据处理 类似子表放在这里
  /*vm.$refs["baseCodeTable"].getChildData((child, del) => {
      entities.codeList = child;
      entities.delIdList = del.map(val => {
          return val.codeId;
      });
  });*/

  let baseCodeTable = await this.getChildDataNew('baseCodeTable');
  if (baseCodeTable.msg) {
    throw baseCodeTable.msg
  } else {
    entities.codeList = baseCodeTable.child;
    entities.delIdList = baseCodeTable.del.map(val => {
      return val.codeId;
    });
  }

  //entities.typeNo = vm.keyId;
  entities.controlState = 1;
  entities.createUserId = vm.createUserId;
  entities.createDate = vm.createDate;
  return await dataApi.saveFormDetail(entities).then(() => {
    this.$emit('saved')
  });
}


/**
 * 表单组件
 */
export default {
  /*props: {
      rowId: {
          type: String,
          default: ''
      },
  },*/
  mixins: [formMixin],
  components: {
    baseCodeTable,
  },
  data() {
    return {
      editStatus: true,
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
  },
};
</script>

<style scoped lang="less">
</style>